enum OrderBy {
  DESC = "DESC",
  ASC = "ASC"
}

export default OrderBy;
